// | Based on Restaumatic.Calendar.Types.Availability in higgs
import * as $runtime from "../runtime.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dDate$dComponent from "../Data.Date.Component/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dEuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const $AvailabilityStatus = (tag, _1) => ({tag, _1});
const toIsSymbol = {reflectSymbol: () => "to"};
const fromIsSymbol = {reflectSymbol: () => "from"};
const wednesdayIsSymbol = {reflectSymbol: () => "wednesday"};
const tuesdayIsSymbol = {reflectSymbol: () => "tuesday"};
const thursdayIsSymbol = {reflectSymbol: () => "thursday"};
const sundayIsSymbol = {reflectSymbol: () => "sunday"};
const saturdayIsSymbol = {reflectSymbol: () => "saturday"};
const mondayIsSymbol = {reflectSymbol: () => "monday"};
const fridayIsSymbol = {reflectSymbol: () => "friday"};
const intercalate = sep => xs => Data$dFoldable.foldlArray(v => v1 => {
  if (v.init) { return {init: false, acc: v1}; }
  return {init: false, acc: v.acc + sep + v1};
})({init: true, acc: ""})(xs).acc;
const any = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupDisj1 = {append: v => v1 => v || v1};
  return {mempty: false, Semigroup0: () => semigroupDisj1};
})()))();
const SecondsOfDay = x => x;
const SecondOfDayRange = x => x;
const DailyAvailability = x => x;
const WeeklyAvailability = x => x;
const Available = /* #__PURE__ */ $AvailabilityStatus("Available");
const NotAvailableWholeDay = /* #__PURE__ */ $AvailabilityStatus("NotAvailableWholeDay");
const NotAvailableAtTheTime = value0 => $AvailabilityStatus("NotAvailableAtTheTime", value0);
const newtypeWeeklyAvailability = {Coercible0: () => {}};
const newtypeSecondsOfDay_ = {Coercible0: () => {}};
const newtypeSecondOfDayRange_ = {Coercible0: () => {}};
const newtypeDailyAvailability_ = {Coercible0: () => {}};
const genericWeeklyAvailability = {to: x => x, from: x => x};
const genericSecondsOfDay_ = {to: x => x, from: x => x};
const genericSecondOfDayRange_ = {to: x => x, from: x => x};
const genericDailyAvailability_ = {to: x => x, from: x => x};
const genericAvailabilityStatus = {
  to: x => {
    if (x.tag === "Inl") { return Available; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return NotAvailableWholeDay; }
      if (x._1.tag === "Inr") { return $AvailabilityStatus("NotAvailableAtTheTime", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Available") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "NotAvailableWholeDay") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "NotAvailableAtTheTime") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const eqSecondsOfDay = {eq: x => y => x === y};
const ordSecondsOfDay = {compare: x => y => Data$dOrd.ordInt.compare(x)(y), Eq0: () => eqSecondsOfDay};
const eqSecondOfDayRange = {eq: x => y => x.from === y.from && x.to === y.to};
const eqArray = /* #__PURE__ */ (() => ({eq: Data$dEq.eqArrayImpl(eqSecondOfDayRange.eq)}))();
const eqDailyAvailability = eqArray;
const eqWeeklyAvailability = {
  eq: x => y => eqArray.eq(x.friday)(y.friday) && eqArray.eq(x.monday)(y.monday) && eqArray.eq(x.saturday)(y.saturday) && eqArray.eq(x.sunday)(y.sunday) && eqArray.eq(x.thursday)(y.thursday) && eqArray.eq(x.tuesday)(y.tuesday) && eqArray.eq(x.wednesday)(y.wednesday)
};
const eqAvailabilityStatus = {
  eq: x => y => {
    if (x.tag === "Available") { return y.tag === "Available"; }
    if (x.tag === "NotAvailableWholeDay") { return y.tag === "NotAvailableWholeDay"; }
    if (x.tag === "NotAvailableAtTheTime") {
      if (y.tag === "NotAvailableAtTheTime") { return eqArray.eq(x._1)(y._1); }
      return false;
    }
    return false;
  }
};
const encodeSecondsOfDay = Foreign$dGeneric$dClass.intEncode;
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeSecondOfDayRange = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(toIsSymbol)(encodeWithOptionsOther))(fromIsSymbol)(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const encodeDailyAvailability = /* #__PURE__ */ (() => ({encode: Data$dFunctor.arrayMap(encodeSecondOfDayRange.encode)}))();
const encodeWithOptionsOther1 = {encodeWithOptions: v => encodeDailyAvailability.encode};
const encodeWeeklyAvailability = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(wednesdayIsSymbol)(encodeWithOptionsOther1))(tuesdayIsSymbol)(encodeWithOptionsOther1))(thursdayIsSymbol)(encodeWithOptionsOther1))(sundayIsSymbol)(encodeWithOptionsOther1))(saturdayIsSymbol)(encodeWithOptionsOther1))(mondayIsSymbol)(encodeWithOptionsOther1))(fridayIsSymbol)(encodeWithOptionsOther1).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const decodeSecondsOfDay = Unscramble.decodeInt1;
const decodeSecondsOfDay1 = Foreign$dGeneric$dClass.intDecode;
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeSecondOfDayRange = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(fromIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(toIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const decodeSecondOfDayRange1 = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(toIsSymbol)(decodeWithOptionsOther)())(fromIsSymbol)(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const decodeDailyAvailability = /* #__PURE__ */ (() => ({unsafeDecode: Unscramble.decodeArray(decodeSecondOfDayRange.unsafeDecode)}))();
const decodeWeeklyAvailability = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(fridayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordCons(mondayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordCons(saturdayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordCons(sundayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordCons(thursdayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordCons(tuesdayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordCons(wednesdayIsSymbol)(decodeDailyAvailability)(Unscramble.decodeRecordNil))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const decodeDailyAvailability1 = /* #__PURE__ */ Foreign$dGeneric$dClass.arrayDecode(decodeSecondOfDayRange1);
const decodeWithOptionsOther1 = {decodeWithOptions: v => decodeDailyAvailability1.decode};
const decodeWeeklyAvailability1 = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(wednesdayIsSymbol)(decodeWithOptionsOther1)())(tuesdayIsSymbol)(decodeWithOptionsOther1)())(thursdayIsSymbol)(decodeWithOptionsOther1)())(sundayIsSymbol)(decodeWithOptionsOther1)())(saturdayIsSymbol)(decodeWithOptionsOther1)())(mondayIsSymbol)(decodeWithOptionsOther1)())(fridayIsSymbol)(decodeWithOptionsOther1)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const secondsToTimeShort = v => {
  const minute = Data$dEuclideanRing.intDiv(Data$dEuclideanRing.intMod(v)(3600))(60);
  const hour = Data$dEuclideanRing.intDiv(v)(3600) === 24 ? 24 : Data$dEuclideanRing.intMod(Data$dEuclideanRing.intDiv(v)(3600))(24);
  return (hour > 9 ? "" : "0") + Data$dShow.showIntImpl(hour) + ":" + (minute > 9 ? "" : "0") + Data$dShow.showIntImpl(minute);
};
const secondsToTime = v => {
  const second = Data$dEuclideanRing.intMod(v)(60);
  const minute = Data$dEuclideanRing.intDiv(Data$dEuclideanRing.intMod(v)(3600))(60);
  const hour = Data$dEuclideanRing.intDiv(v)(3600);
  const $0 = second !== 0;
  const $1 = ":" + (second > 9 ? "" : "0") + Data$dShow.showIntImpl(second);
  return (hour > 9 ? "" : "0") + Data$dShow.showIntImpl(hour) + ":" + (minute > 9 ? "" : "0") + Data$dShow.showIntImpl(minute) + (() => {
    if (!$0) { return ""; }
    if ($0) { return $1; }
    $runtime.fail();
  })();
};
const editAsStringSecondsOfDay = {
  toString: secondsToTime,
  parse: str => {
    const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid_secondsofday), {});
    const v = Data$dString$dCommon.split(":")(str);
    const $1 = (() => {
      if (v.length === 3) {
        return Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply((() => {
          const $1 = Data$dInt.fromString(v[0]);
          if ($1.tag === "Just") {
            return Data$dMaybe.$Maybe(
              "Just",
              (() => {
                const $2 = $1._1;
                return v1 => v2 => {
                  const v3 = v4 => {
                    if ($2 === 24) {
                      if (v1 === 0) {
                        if (v2 === 0) { return Data$dMaybe.$Maybe("Just", ((3600 * $2 | 0) + (60 * v1 | 0) | 0) + v2 | 0); }
                        return Data$dMaybe.Nothing;
                      }
                      return Data$dMaybe.Nothing;
                    }
                    return Data$dMaybe.Nothing;
                  };
                  if ($2 >= 0) {
                    if ($2 <= 23) {
                      if (v1 >= 0) {
                        if (v1 < 60) {
                          if (v2 >= 0) {
                            if (v2 < 60) { return Data$dMaybe.$Maybe("Just", ((3600 * $2 | 0) + (60 * v1 | 0) | 0) + v2 | 0); }
                            return v3(true);
                          }
                          return v3(true);
                        }
                        return v3(true);
                      }
                      return v3(true);
                    }
                    return v3(true);
                  }
                  return v3(true);
                };
              })()
            );
          }
          return Data$dMaybe.Nothing;
        })())(Data$dInt.fromString(v[1])))(Data$dInt.fromString(v[2]));
      }
      if (v.length === 2) {
        return Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply((() => {
          const $1 = Data$dInt.fromString(v[0]);
          if ($1.tag === "Just") {
            return Data$dMaybe.$Maybe(
              "Just",
              (() => {
                const $2 = $1._1;
                return v1 => v2 => {
                  const v3 = v4 => {
                    if ($2 === 24) {
                      if (v1 === 0) {
                        if (v2 === 0) { return Data$dMaybe.$Maybe("Just", ((3600 * $2 | 0) + (60 * v1 | 0) | 0) + v2 | 0); }
                        return Data$dMaybe.Nothing;
                      }
                      return Data$dMaybe.Nothing;
                    }
                    return Data$dMaybe.Nothing;
                  };
                  if ($2 >= 0) {
                    if ($2 <= 23) {
                      if (v1 >= 0) {
                        if (v1 < 60) {
                          if (v2 >= 0) {
                            if (v2 < 60) { return Data$dMaybe.$Maybe("Just", ((3600 * $2 | 0) + (60 * v1 | 0) | 0) + v2 | 0); }
                            return v3(true);
                          }
                          return v3(true);
                        }
                        return v3(true);
                      }
                      return v3(true);
                    }
                    return v3(true);
                  }
                  return v3(true);
                };
              })()
            );
          }
          return Data$dMaybe.Nothing;
        })())(Data$dInt.fromString(v[1])))(Data$dMaybe.$Maybe("Just", 0));
      }
      return Data$dMaybe.Nothing;
    })();
    const $2 = (() => {
      if ($1.tag === "Just") { return $1._1; }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if ($2.tag === "Nothing") { return Data$dEither.$Either("Left", $0); }
    if ($2.tag === "Just") { return Data$dEither.$Either("Right", $2._1); }
    $runtime.fail();
  }
};
const showSecondsOfDay = {show: secondsToTime};
const showSecondOfDayRange = {show: record => "{ from: " + secondsToTime(record.from) + ", to: " + secondsToTime(record.to) + " " + "}"};
const showDailyAvailability = /* #__PURE__ */ (() => ({show: Data$dShow.showArrayImpl(showSecondOfDayRange.show)}))();
const showAvailabilityStatus = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Available"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NotAvailableWholeDay"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [showDailyAvailability.show(v)]})({reflectSymbol: () => "NotAvailableAtTheTime"});
    return x => {
      const $3 = genericAvailabilityStatus.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showWeeklyAvailability = {
  show: record => "{ friday: " + showDailyAvailability.show(record.friday) + ", monday: " + showDailyAvailability.show(record.monday) + ", saturday: " + showDailyAvailability.show(record.saturday) + ", sunday: " + showDailyAvailability.show(record.sunday) + ", thursday: " + showDailyAvailability.show(record.thursday) + ", tuesday: " + showDailyAvailability.show(record.tuesday) + ", wednesday: " + showDailyAvailability.show(record.wednesday) + " " + "}"
};
const overWeeklyAvailability = Unsafe$dCoerce.unsafeCoerce;
const none = [];
const noneWeek = {monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [], sunday: []};
const mkRange = from => to => ({from, to});
const isInRange = v => seconds => seconds >= v.from && seconds < v.to;
const getDailyAvailability = v => weekday => {
  if (weekday.tag === "Monday") { return v.monday; }
  if (weekday.tag === "Tuesday") { return v.tuesday; }
  if (weekday.tag === "Wednesday") { return v.wednesday; }
  if (weekday.tag === "Thursday") { return v.thursday; }
  if (weekday.tag === "Friday") { return v.friday; }
  if (weekday.tag === "Saturday") { return v.saturday; }
  if (weekday.tag === "Sunday") { return v.sunday; }
  $runtime.fail();
};
const fromArrayStartOnSunday = v => {
  if (v.length === 7) { return Data$dMaybe.$Maybe("Just", {sunday: v[0], monday: v[1], tuesday: v[2], wednesday: v[3], thursday: v[4], friday: v[5], saturday: v[6]}); }
  return Data$dMaybe.Nothing;
};
const formatDailyAvailability = v => intercalate(", ")(Data$dFunctor.arrayMap(v1 => secondsToTimeShort(v1.from) + "-" + secondsToTimeShort(v1.to))(v));
const dailyAvailabilityStatus = daily => time => {
  if (any(range => time >= range.from && time < range.to)(daily)) { return Available; }
  if (eqArray.eq(daily)([])) { return NotAvailableWholeDay; }
  return $AvailabilityStatus("NotAvailableAtTheTime", daily);
};
const circularPred = x => {
  const $0 = Data$dDate$dComponent.enumWeekday.pred(x);
  if ($0.tag === "Nothing") { return Data$dDate$dComponent.Sunday; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
};
const availabilityStatusOnWeekday = availability => weekday => time => {
  if (
    eqAvailabilityStatus.eq(dailyAvailabilityStatus((() => {
      const $0 = Data$dDate$dComponent.enumWeekday.pred(weekday);
      const $1 = (() => {
        if ($0.tag === "Nothing") { return Data$dDate$dComponent.Sunday; }
        if ($0.tag === "Just") { return $0._1; }
        $runtime.fail();
      })();
      if ($1.tag === "Monday") { return availability.monday; }
      if ($1.tag === "Tuesday") { return availability.tuesday; }
      if ($1.tag === "Wednesday") { return availability.wednesday; }
      if ($1.tag === "Thursday") { return availability.thursday; }
      if ($1.tag === "Friday") { return availability.friday; }
      if ($1.tag === "Saturday") { return availability.saturday; }
      if ($1.tag === "Sunday") { return availability.sunday; }
      $runtime.fail();
    })())(time + 86400 | 0))(Available)
  ) {
    return Available;
  }
  return dailyAvailabilityStatus((() => {
    if (weekday.tag === "Monday") { return availability.monday; }
    if (weekday.tag === "Tuesday") { return availability.tuesday; }
    if (weekday.tag === "Wednesday") { return availability.wednesday; }
    if (weekday.tag === "Thursday") { return availability.thursday; }
    if (weekday.tag === "Friday") { return availability.friday; }
    if (weekday.tag === "Saturday") { return availability.saturday; }
    if (weekday.tag === "Sunday") { return availability.sunday; }
    $runtime.fail();
  })())(time);
};
const availabilityStatus = availability => v => availabilityStatusOnWeekday(availability)(Data$dDate.weekday(v._1))(((v._2._1 * 3600 | 0) + (v._2._2 * 60 | 0) | 0) + v._2._3 | 0);
const isAvailable = availability => dt => eqAvailabilityStatus.eq(availabilityStatus(availability)(dt))(Available);
const isAvailableNowOrLaterOnThatDay = availability => v => {
  const v1 = availabilityStatus(availability)(v);
  if (v1.tag === "NotAvailableAtTheTime") {
    const $0 = ((v._2._1 * 3600 | 0) + (v._2._2 * 60 | 0) | 0) + v._2._3 | 0;
    return any(range => $0 <= range.from)(v1._1);
  }
  if (v1.tag === "Available") { return true; }
  if (v1.tag === "NotAvailableWholeDay") { return false; }
  $runtime.fail();
};
const isAvailableOnThatDay = availability => dt => !eqAvailabilityStatus.eq(availabilityStatus(availability)(dt))(NotAvailableWholeDay);
const isAvailableOnlyLaterOnThatDay = availability => v => {
  const v1 = availabilityStatus(availability)(v);
  if (v1.tag === "NotAvailableAtTheTime") {
    const $0 = ((v._2._1 * 3600 | 0) + (v._2._2 * 60 | 0) | 0) + v._2._3 | 0;
    return any(range => $0 <= range.from)(v1._1);
  }
  return false;
};
const allDay = [{from: 0, to: 86400}];
const allWeek = {monday: allDay, tuesday: allDay, wednesday: allDay, thursday: allDay, friday: allDay, saturday: allDay, sunday: allDay};
const isAvailableWholeDay = availability => v => {
  const $0 = Data$dDate.weekday(v._1);
  return eqArray.eq((() => {
    if ($0.tag === "Monday") { return availability.monday; }
    if ($0.tag === "Tuesday") { return availability.tuesday; }
    if ($0.tag === "Wednesday") { return availability.wednesday; }
    if ($0.tag === "Thursday") { return availability.thursday; }
    if ($0.tag === "Friday") { return availability.friday; }
    if ($0.tag === "Saturday") { return availability.saturday; }
    if ($0.tag === "Sunday") { return availability.sunday; }
    $runtime.fail();
  })())(allDay);
};
export {
  $AvailabilityStatus,
  Available,
  DailyAvailability,
  NotAvailableAtTheTime,
  NotAvailableWholeDay,
  SecondOfDayRange,
  SecondsOfDay,
  WeeklyAvailability,
  allDay,
  allWeek,
  any,
  availabilityStatus,
  availabilityStatusOnWeekday,
  circularPred,
  dailyAvailabilityStatus,
  decodeDailyAvailability,
  decodeDailyAvailability1,
  decodeSecondOfDayRange,
  decodeSecondOfDayRange1,
  decodeSecondsOfDay,
  decodeSecondsOfDay1,
  decodeWeeklyAvailability,
  decodeWeeklyAvailability1,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  editAsStringSecondsOfDay,
  encodeDailyAvailability,
  encodeSecondOfDayRange,
  encodeSecondsOfDay,
  encodeWeeklyAvailability,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  eqArray,
  eqAvailabilityStatus,
  eqDailyAvailability,
  eqSecondOfDayRange,
  eqSecondsOfDay,
  eqWeeklyAvailability,
  formatDailyAvailability,
  fridayIsSymbol,
  fromArrayStartOnSunday,
  fromIsSymbol,
  genericAvailabilityStatus,
  genericDailyAvailability_,
  genericSecondOfDayRange_,
  genericSecondsOfDay_,
  genericWeeklyAvailability,
  getDailyAvailability,
  intercalate,
  isAvailable,
  isAvailableNowOrLaterOnThatDay,
  isAvailableOnThatDay,
  isAvailableOnlyLaterOnThatDay,
  isAvailableWholeDay,
  isInRange,
  mkRange,
  mondayIsSymbol,
  newtypeDailyAvailability_,
  newtypeSecondOfDayRange_,
  newtypeSecondsOfDay_,
  newtypeWeeklyAvailability,
  none,
  noneWeek,
  ordSecondsOfDay,
  overWeeklyAvailability,
  saturdayIsSymbol,
  secondsToTime,
  secondsToTimeShort,
  showAvailabilityStatus,
  showDailyAvailability,
  showSecondOfDayRange,
  showSecondsOfDay,
  showWeeklyAvailability,
  sundayIsSymbol,
  thursdayIsSymbol,
  toIsSymbol,
  tuesdayIsSymbol,
  wednesdayIsSymbol
};
